import type { CustomCellRendererProps } from '@cmg/data-grid';
import { SvgIcon } from '@cmg/design-system';
import React from 'react';

import CmgLogo from '../../assets/identity-icon.svg?react';

export function OnPlatformCellRenderer<TData, TContext>({
  value,
}: Readonly<CustomCellRendererProps<TData, boolean, TContext>>) {
  if (!value) {
    return null;
  }

  return (
    <SvgIcon fontSize="small" aria-label="On platform" role="img">
      <CmgLogo />
    </SvgIcon>
  );
}
